export default "__VITE_ASSET__DIS68$gI__"